import { createSlice } from '@reduxjs/toolkit';

export const questionsSlice = createSlice({
    name: 'questions',
    initialState: {
        data: null,
    },
    reducers: {
        setQuestions: (state, {payload}) => {
            state.data = payload;
        }
    },
});

export const {
    setQuestions,
} = questionsSlice.actions;

export default questionsSlice.reducer;
